import { ReactElement } from "react";
import { cva } from "class-variance-authority";
import clsx from "clsx";

import FeaturedIcon, { FeaturedIconProps } from "@/components/atoms/FeaturedIcon";

type FeaturedTextProps = {
  featuredIcon?: FeaturedIconProps;
  heading: string | ReactElement;
  body: string | ReactElement;
  children?: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
};

const FeaturedTextVariants = cva("grid justify-center gap-2 text-center", {
  variants: {
    size: {
      sm: "max-w-64",
      md: "max-w-80",
      lg: "max-w-96",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

const FeaturedText = ({ featuredIcon, heading, body, className, size, children }: FeaturedTextProps) => {
  return (
    <div className={clsx("flex flex-grow flex-col items-center justify-center gap-3", className)}>
      {featuredIcon && <FeaturedIcon {...featuredIcon} />}
      <div className={clsx(FeaturedTextVariants({ size }))}>
        <h2 className="text-xl font-semibold text-primary">{heading}</h2>
        <p className="break-words text-sm text-tertiary">{body}</p>
        {children}
      </div>
    </div>
  );
};

export default FeaturedText;
